// Thumbnails (§8): 320 px, made in the decode worker, cached in IndexedDB by name|size|lastModified.
import { createStore, get, set, del, type UseStore } from 'idb-keyval';
import { decodePool } from './decode/pool';
import type { ExifSummary } from './decode/types';

export type ThumbRecord = {
  blob: Blob;
  width: number;
  height: number;
  srcWidth: number;
  srcHeight: number;
  exif: ExifSummary;
};

let store: UseStore | null = null;
const thumbStore = () => (store ??= createStore('epb-thumbs', 'thumbs'));

export const fileKey = (f: { name: string; size: number; lastModified: number }) =>
  `${f.name}|${f.size}|${f.lastModified}`;

/** Counter for tests: how many thumbnails were actually generated (cache misses). */
export const thumbStats = { generated: 0, cacheHits: 0 };

export async function getThumbnail(file: File): Promise<ThumbRecord> {
  const key = fileKey(file);
  try {
    const hit = await get<ThumbRecord>(key, thumbStore());
    if (hit) {
      thumbStats.cacheHits++;
      return hit;
    }
  } catch {
    /* IndexedDB unavailable: generate every time */
  }
  const rec = await decodePool().thumbnail(file);
  thumbStats.generated++;
  try {
    await set(key, rec, thumbStore());
  } catch {
    /* ignore */
  }
  return rec;
}

export async function forgetThumbnail(file: { name: string; size: number; lastModified: number }) {
  try {
    await del(fileKey(file), thumbStore());
  } catch {
    /* ignore */
  }
}
